import axios, { AxiosInstance, ResponseType } from "axios"
import { ServerErrorScheme } from "../../../backend/src/routes/schemes"
import { StatusCodes } from "../../../backend/src/routes/statuses"
import _ from "lodash"

export const apiSettings = (parameters?: ApiRequestParameters) => {
    return {
        baseURL: parameters?.baseUrl || import.meta.env.VITE_API_URL,
        withCredentials: true,
        headers: {
            "Content-type": parameters?.type || "application/json",
            Authorization: parameters?.token ? `Bearer ${parameters.token}` : undefined,
        },
        responseType: parameters?.responseType,
    }
}

export const api = (parameters?: ApiRequestParameters): AxiosInstance => {
    return axios.create(apiSettings(parameters))
}

interface ApiRequestParameters {
    baseUrl?: string
    type?: "application/json" | "multipart/form-data"
    responseType?: ResponseType
    token?: string
}

export const createSearchParams = (obj: any) => {
    const params = new URLSearchParams(obj || {})
    Object.keys(obj).map((x) => {
        if (_.isArray(obj[x])) {
            params.delete(x)
            ;(obj[x] as any[]).map((param) => params.append(x, param.toString()))
        }
    })
    return params.toString()
}

export type ApiError = ServerErrorScheme
export const ApiErrorCodes = StatusCodes
